export const fetchAddressFromOla = async (lat, lng, apiKey, options = {}) => {
  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), 10000); // 10 second timeout

  try {
    const url = `https://api.olamaps.io/places/v1/reverse-geocode?latlng=${lat},${lng}&api_key=${apiKey}`;
    const response = await fetch(url, {
      ...options,
      signal: controller.signal
    });

    clearTimeout(timeoutId);

    if (!response.ok) throw new Error(`API error: ${response.status}`);

    const data = await response.json();

    if (!data?.results?.[0]) {
      throw new Error('No address data in response');
    }

    return {
      address: data.results[0]?.formatted_address || 'Address not found',
      accuracy: data.results[0]?.accuracy || 'N/A',
      latitude: lat,
      longitude: lng,
      placeId: data.results[0]?.place_id || '',
      addressComponents: data.results[0]?.address_components || []
    };
  } catch (error) {
    clearTimeout(timeoutId);
    console.error('Error fetching address:', error);
    // Instead of throwing, return a default object
    return {
      address: 'Address not available',
      accuracy: 'N/A',
      latitude: lat,
      longitude: lng,
      placeId: '',
      addressComponents: []
    };
  }
};
